import { Localized } from '../locale/locale.model';

export const enum ContactRole {
  Requester,
  Observer,
  Manager
}

export type LocalizedContactRole = Localized<ContactRole>;
export const convertContactRole = (role: accounts.ContactRole): LocalizedContactRole => {
  const value = (role as number) as ContactRole;
  switch (value) {
    case ContactRole.Requester:
      return { value, localizationKey: 'ContactRole.requester' };
    case ContactRole.Observer:
      return { value, localizationKey: 'ContactRole.observer' };
    case ContactRole.Manager:
      return { value, localizationKey: 'ContactRole.manager' };
    default:
      throw new Error('Invalid contact role');
  }
};

export const getLocalizedContactRole = (role: ContactRole) => convertContactRole(role as number);

export interface LoginRequest {
  email: string;
  password: string;
}

export interface PasswordChange {
  email: string;
  oldPassword: string;
  newPassword: string;
}

export class PmInfo {
  name: string;
  emailAddress: string;

  constructor(info: accounts.PmInfo) {
    this.name = info.Name;
    this.emailAddress = info.EmailAddress;
  }
}

export class User {
  readonly isAuthenticated: boolean;
  name?: string;
  email?: string;
  role?: LocalizedContactRole;

  constructor(
    isAuthenticated: boolean,
    name?: string,
    email?: string,
    role?: LocalizedContactRole
  ) {
    this.isAuthenticated = isAuthenticated;
    this.name = name;
    this.email = email;
    this.role = role;
  }

  get isRequester() {
    return !!this.role && this.role.value === ContactRole.Requester;
  }

  get isObserver() {
    return !!this.role && this.role.value === ContactRole.Observer;
  }

  get isManager() {
    return !!this.role && this.role.value === ContactRole.Manager;
  }
}

export class OidcLoginParameters {
  loginId: string;
  loginIdHash: string;
}
